import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Card.scss'

const Card = ({
  children, className, elementType, noPadding, cardAdmin, ...rest
}) => {
  const Element = elementType
  const classes = {
    [styles.noPadding]: noPadding,
    [styles.cardAdmin]: cardAdmin,
  }

  return (
    <Element {...rest} className={classnames(styles.card, classes, className)} >
      {children}
    </Element>
  )
}

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  elementType: PropTypes.string,
  noPadding: PropTypes.bool,
  cardAdmin: PropTypes.bool,
}

Card.defaultProps = {
  elementType: 'div',
  children: null,
  className: null,
  noPadding: false,
  cardAdmin: false,
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/Card.js